<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <div id="StockTransferInformation" class="modalBox">
              <div class="infoTitle">
                <div class="flex-ct">
                  <i class="leftLine"></i>
                  <span>{{ $t('调拨单信息') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                  <a-tag
                    v-if="isEdit && formData.status"
                    style="font-size: 12px; font-weight: normal; margin-left: 10px"
                  >
                    {{ $t(`form.${formData.status}`) }}
                  </a-tag>
                  <a-icon type="sync" class="text-main" @click="refreshHandle" />
                </div>
                <div></div>
                <div v-if="formData.status && formData.status !== 'CANCEL'">
                  <a-button
                    v-if="!isShow && !isInfoShow && formData.status === 'WAIT_CHECK'"
                    type="primary"
                    @click="onReview"
                  >
                    {{ $t(`form.Review`) }}
                  </a-button>
                  <a-button
                    v-if="
                      !isShow &&
                      !isInfoShow &&
                      formData.status &&
                      (formData.status == 'WAIT_CHECK' ||
                        formData.status == 'WAIT_OUTBOUND' ||
                        formData.status == 'WAIT_PUSH' ||
                        formData.status == 'PUSH_FAIL')
                    "
                    type="danger"
                    @click="onVoidOrder"
                  >
                    {{ $t(`form.VoidOrder`) }}
                  </a-button>
                </div>
              </div>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ShippingWarehouse`)" :required="true">
                    <SelectWarehouseNew
                      :placeholder="$t(`form.ShippingWarehouse`)"
                      style="width: 100%"
                      :disabled="isDisabled"
                      :code.sync="formData.outboundWarehouseCode"
                      @change="outboundWarehouseCodeChange"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ShipperName`)">
                    <a-input
                      allow-clear
                      v-model.trim="formData.senderName"
                      :placeholder="$t(`form.ShipperName`)"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ShippersContactInformation`)">
                    <a-input
                      allow-clear
                      v-model.trim="formData.senderPhone"
                      :placeholder="$t(`form.ShippersContactInformation`)"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ReceivingWarehouse`)" :required="true">
                    <SelectWarehouseNew
                      :placeholder="$t(`form.ReceivingWarehouse`)"
                      style="width: 100%"
                      :disabled="isDisabled"
                      :code.sync="formData.inboundWarehouseCode"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ConsigneeName`)">
                    <a-input
                      allow-clear
                      v-model.trim="formData.receiverName"
                      :placeholder="$t(`form.ConsigneeName`)"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.consigneesContactInformation`)">
                    <a-input
                      allow-clear
                      v-model.trim="formData.receiverPhone"
                      :placeholder="$t(`form.consigneesContactInformation`)"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.AssociatedBatchNumber`)">
                    <a-input
                      allow-clear
                      v-model.trim="formData.batchNo"
                      :placeholder="$t(`form.AssociatedBatchNumber`)"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.TypeOfShipping`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`form.TypeOfShipping`)"
                      style="width: 100%"
                      v-model="formData.shippingMethod"
                      :disabled="isDisabled"
                    >
                      <a-select-option
                        v-for="item in shippingList"
                        :key="item.code"
                        :value="item.code"
                      >
                        {{ item.shippingName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ExpectedArrivalDate`)">
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.estimatedArrivalTime"
                      @choose="chooseEstimatedArrivalTime"
                      :disabled="isDisabled"
                      :placehold="$t(`form.ExpectedArrivalDate`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.note`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.note"
                      :placeholder="$t(`form.note`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="transferOrderId">
                  <a-form-model-item :label="$t(`form.WarehouseDeliveryOrderNo`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.outboundOrderSn"
                      :placeholder="$t(`form.WarehouseDeliveryOrderNo`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="transferOrderId">
                  <a-form-model-item :label="$t(`form.WarehouseReceiptNo`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.inboundOrderSn"
                      :placeholder="$t(`form.WarehouseReceiptNo`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ExportTime`)">
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.exitTime"
                      @choose="
                        (data) => {
                          formData.exitTime = data.data
                        }
                      "
                      :disabled="isDisabled"
                      :placehold="$t(`form.ExportTime`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.CustomsDeclarationNumber`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.customsDeclarationNumber"
                      :placeholder="$t(`form.CustomsDeclarationNumber`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.Currency`)">
                    <SelectCurrency :value.sync="formData.currency" :disabled="isDisabled" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`出库库存渠道`)" required>
                    <!-- 不指定渠道 null -->
                    <SelectPlatform
                      :value.sync="formData.outboundPlatform"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`库存类型`)" required>
                    <a-select
                      style="width: 100%"
                      v-model="formData.inventoryStatus"
                      :disabled="isDisabled"
                      @change="changeInventoryStatus"
                    >
                      <a-select-option value="CERTIFIED_PRODUCTS">
                        {{ $t('正品') }}
                      </a-select-option>
                      <a-select-option value="DEFECTIVE_PRODUCTS">
                        {{ $t('次品') }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="!isRent">
                  <a-form-model-item :label="$t(`创建到货通知时合并相同商品`)" required>
                    <a-select
                      style="width: 100%"
                      v-model="formData.needMergeSku"
                      :disabled="isDisabled"
                    >
                      <a-select-option :value="1">
                        {{ $t('是') }}
                      </a-select-option>
                      <a-select-option :value="0">
                        {{ $t('否') }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
          <div id="ProductInfo" class="modalBox">
            <a-form-model>
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  {{ $t('form.ProductInfo') }}
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isInfoShow = !isInfoShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createInfoForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelInfoEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
                <div class="txt">
                  <span style="margin-right: 30px">
                    {{ $t('调拨总数量') }}: {{ transferredAllQuantity | toThousands }}
                  </span>
                  <span style="margin-right: 30px">
                    {{ $t('出库总数量') }}: {{ issuedAllQuantity | toThousands }}
                  </span>
                  <span>{{ $t('入库总数量') }}: {{ receivedAllQuantity | toThousands }}</span>
                </div>
              </div>
              <a-row v-if="!editShow || (editShow && isInfoShow)" style="display: flex">
                <a-col style="position: relative; display: flex; align-items: center">
                  <SearchSku style="width: 300px" @selected="handleChangeSku" />
                  <div class="quick-search" v-if="isRent">
                    <a-input
                      v-model="imeiSn"
                      :placeholder="$t('输入 IMEI/SN 自动查询库存')"
                      allow-clear
                      style="width: 260px; margin-left: 10px"
                      @change="handleImeiSnChange"
                    >
                      <a-icon v-if="imeiSnLoading" slot="suffix" type="loading" />
                    </a-input>
                    <a-button type="primary" style="margin-left: 10px" @click="showSkuModal">
                      {{ $t('SKU快捷查询') }}
                    </a-button>
                    <SkuQuickQueryModal ref="skuModal" @selected="onSkuSelected" />
                  </div>
                  <a-button type="primary" style="margin-left: 10px" @click="addGoodsToTable">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('form.Add') }}
                  </a-button>
                </a-col>
              </a-row>
              <a-row
                v-if="!editShow || (editShow && isInfoShow && formData.status === 'WAIT_CHECK')"
                style="margin: 8px 0 0 0; display: flex"
              >
                <a-col>
                  <a-button type="primary" @click="showImportModal">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t(`form.BatchImport`) }}
                  </a-button>
                </a-col>
                <a-col style="margin-left: 5px">
                  <a-button type="primary" @click="batchNoImportFn">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t(`form.BatchNumberImport`) }}
                  </a-button>
                </a-col>
                <!-- <a-col style="margin-left: 10px">
                  <a-button type="danger" @click="batchDelFn">
                    {{ $t(`form.BatchDelete`) }}
                  </a-button>
                </a-col> -->
              </a-row>
              <a-row>
                <div class="table-wrapper" style="margin-top: 10px">
                  <a-table
                    :columns="isEdit && (!isEdit || !isInfoShow) ? columnsDetail : columns"
                    :dataSource="tableData"
                    bordered
                    size="middle"
                    :loading="tableLoading"
                    :pagination="false"
                    :scroll="{ x: 1000 }"
                    :rowKey="
                      (record, index) => {
                        return index
                      }
                    "
                  >
                    <span slot="ProductBarcode" class="form-table-heard">
                      {{ $t(`form.ProductBarcode`) }}
                    </span>
                    <span slot="SkuNumber">
                      {{ $t(`form.skuNumber`) }}
                    </span>
                    <span slot="BoxNumber" class="form-table-heard">
                      {{ $t(`form.BoxNumber`) }}
                    </span>
                    <span slot="Quantity" class="form-table-heard">{{ $t(`form.Quantity`) }}</span>
                    <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                      <div :key="col">
                        <div v-if="isInfoShow || record.editable">
                          <!-- includes 用来判断当前的输入类型 -->
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :formatter="Formatter"
                            :parser="Formatter"
                            v-if="col === 'caseNo' || col === 'quantity'"
                            :value="text"
                            :min="0"
                            @change="(e) => handleChange(e, record.barcode, col, index)"
                          />
                          <a-input-number
                            v-else-if="col === 'feeAmount' || col === 'unitPriceIncludingTax'"
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :precision="2"
                            :value="text"
                            :min="0"
                            @change="(e) => handleChange(e, record.barcode, col, index)"
                          />
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :value="text"
                            v-else-if="inputScopedSlots.includes(col)"
                            @change="
                              (e) => handleChange(e.target.value, record.barcode, col, index)
                            "
                          />
                          <template v-else-if="col == 'unit'">
                            <a-select
                              v-if="record.unitList?.length > 0"
                              :placeholder="$t(`form.pleaseChoose`)"
                              style="display: block"
                              :value="text"
                              @change="onChangeSelect($event, record.barcode, col, index)"
                            >
                              <a-select-option
                                v-for="(item, index) in record.unitList"
                                :key="index"
                                :value="item.unitNameFull"
                              >
                                {{ item.unitNameFull }}
                              </a-select-option>
                            </a-select>
                            <span v-else>{{ $t('个') }}</span>
                          </template>
                          <template v-else-if="col === 'delect'">
                            <a @click="onDelect(index)">
                              <a-icon type="delete" style="color: red" />
                            </a>
                          </template>
                          <template v-else-if="col === 'inventoryNote'">
                            <div v-if="parseNote(record.inventoryNote)">
                              <div v-if="parseNote(record.inventoryNote).source">
                                {{ $t('来源') }}: {{ parseNote(record.inventoryNote).source }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).imei">
                                IMEI: {{ formatImei(parseNote(record.inventoryNote).imei) }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).battery">
                                {{ $t('电池') }}: {{ parseNote(record.inventoryNote).battery }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).appearance">
                                {{ $t('外观') }}: {{ parseNote(record.inventoryNote).appearance }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).note">
                                {{ $t('备注') }}: {{ parseNote(record.inventoryNote).note }}
                              </div>
                            </div>
                            <div v-else>{{ record.inventoryNote }}</div>
                            <a
                              v-if="isRent && formData.status === 'WAIT_CHECK'"
                              style="margin-left: 8px"
                              @click="openInventoryBatchModal(record)"
                            >
                              {{ $t('指定库存批次') }}
                            </a>
                          </template>
                          <div v-else-if="col === 'note'" style="text-align: left">
                            <template v-if="parseNote(text)">
                              <div v-if="parseNote(text).source">
                                {{ $t('来源') }}: {{ parseNote(text).source }}
                              </div>
                              <div v-if="parseNote(text).imei">
                                IMEI: {{ formatImei(parseNote(text).imei) }}
                              </div>
                              <div v-if="parseNote(text).battery">
                                {{ $t('电池') }}: {{ parseNote(text).battery }}
                              </div>
                              <div v-if="parseNote(text).appearance">
                                {{ $t('外观') }}: {{ parseNote(text).appearance }}
                              </div>
                              <div v-if="parseNote(text).note">
                                {{ $t('备注') }}: {{ parseNote(text).note }}
                              </div>
                            </template>
                            <template v-else>{{ text }}</template>
                          </div>
                          <span v-else>{{ text | toThousands }}</span>
                        </div>
                        <div v-else>
                          <template v-if="col === 'delect'">
                            <a @click="onDelect(index)">
                              <a-icon type="delete" style="color: red" />
                            </a>
                          </template>
                          <template v-else-if="col === 'inventoryNote'">
                            <div v-if="parseNote(record.inventoryNote)">
                              <div v-if="parseNote(record.inventoryNote).source">
                                {{ $t('来源') }}: {{ parseNote(record.inventoryNote).source }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).imei">
                                IMEI: {{ formatImei(parseNote(record.inventoryNote).imei) }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).battery">
                                {{ $t('电池') }}: {{ parseNote(record.inventoryNote).battery }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).appearance">
                                {{ $t('外观') }}: {{ parseNote(record.inventoryNote).appearance }}
                              </div>
                              <div v-if="parseNote(record.inventoryNote).note">
                                {{ $t('备注') }}: {{ parseNote(record.inventoryNote).note }}
                              </div>
                            </div>
                            <div v-else>{{ record.inventoryNote }}</div>
                            <a
                              v-if="isRent && formData.status === 'WAIT_CHECK'"
                              style="margin-left: 8px"
                              @click="openInventoryBatchModal(record)"
                            >
                              {{ $t('指定库存批次') }}
                            </a>
                          </template>
                          <div v-else-if="col === 'note'" style="text-align: left">
                            <template v-if="parseNote(text)">
                              <div v-if="parseNote(text).source">
                                {{ $t('来源') }}: {{ parseNote(text).source }}
                              </div>
                              <div v-if="parseNote(text).imei">
                                IMEI: {{ formatImei(parseNote(text).imei) }}
                              </div>
                              <div v-if="parseNote(text).battery">
                                {{ $t('电池') }}: {{ parseNote(text).battery }}
                              </div>
                              <div v-if="parseNote(text).appearance">
                                {{ $t('外观') }}: {{ parseNote(text).appearance }}
                              </div>
                              <div v-if="parseNote(text).note">
                                {{ $t('备注') }}: {{ parseNote(text).note }}
                              </div>
                            </template>
                            <template v-else>{{ text }}</template>
                          </div>
                          <span v-else>{{ text | toThousands }}</span>
                        </div>
                      </div>
                    </template>
                  </a-table>
                </div>
              </a-row>
            </a-form-model>
          </div>
        </section>
        <OperationLog :list="orderActions" />
      </div>
      <div class="content" style="min-height: 0" v-if="!isEdit">
        <a-row type="flex" justify="center">
          <a-col v-if="formData.status !== 'CANCEL'">
            <a-row type="flex" justify="start" :gutter="16">
              <a-button type="default" @click="backForm">{{ $t(`form.Back`) }}</a-button>
              <a-button
                v-if="editShow && formData.status !== 'FINISH'"
                type="primary"
                @click="onEdit"
              >
                {{ $t(`form.Edit`) }}
              </a-button>
              <a-button
                v-else-if="formData.status !== 'FINISH'"
                type="primary"
                @click="onSubmit"
                :loading="submitLoading"
              >
                {{ $t(`form.Save`) }}
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <!-- 导入采购商品信息数据 -->
    <a-modal
      class="importModal"
      v-model="isImportData"
      :title="modalInfo.modalTitle"
      :width="500"
      :footer="null"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :headers="{ Authorization: sessionId }"
          @change="importData"
          :action="modalInfo.modalUrl"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          class="text-info mt10"
          download
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }} {{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
    <InventoryBatchSelectModal
      :visible.sync="inventoryBatchModalVisible"
      :title="$t('指定库存批次')"
      :barcode="inventoryBatchBarcode"
      :warehouseCode="inventoryBatchWarehouseCode"
      :updateUrl="updateUrl"
      :orderId="transferOrderId"
      orderIdParamName="transferOrderId"
      :orderItemId="inventoryBatchGoodsId"
      orderItemIdParamName="transferOrderItemId"
      @saved="getList"
    />
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import SelectCurrency from '@component/selectCurrency/index.vue'
import { getCookie } from '@/common/cookie'
import SearchSku from '@component/searchSku'
import DatePicker from '@component/datePicker'
import formatter from '@/common/formatter'
import { toThousands } from '@/common/filters'
import { add } from '@/common/number'
import debounce from '@common/debounce'
import OperationLog from '@component/operationLog'
import SelectPlatform from '@component/selectPlatform'
import deepClone from '@/common/deepClone'
import SkuQuickQueryModal from '@component/skuQuickQueryModal.vue'
import { mapGetters } from 'vuex'
import InventoryBatchSelectModal from '@component/inventoryBatchSelectModal.vue'
import SelectWarehouseNew from '@component/selectWarehouseNew'
var _self = {}
export default {
  name: 'addTransfer',
  components: {
    SelectCurrency,
    SearchSku,
    DatePicker,
    OperationLog,
    SelectPlatform,
    SkuQuickQueryModal,
    InventoryBatchSelectModal,
    SelectWarehouseNew,
  },
  data() {
    return {
      loading: false,
      editShow: false,
      isEdit: false,
      isShow: false,
      isInfoShow: false,
      transferOrderId: '',
      orderActions: [],
      orderSnList: [],
      // 表格数据
      tableData: [],
      // 每一列的插槽名 - 表格行内编辑用
      customRenderList: [
        'note',
        'inventoryNote',
        'delect',
        'unit',
        'caseNo',
        'quantity',
        'unitPriceIncludingTax',
        'feeAmount',
      ],
      // 用来匹配插槽中显示input框
      inputScopedSlots: ['caseNo', 'note', 'quantity', 'unitPriceIncludingTax'],
      // 用来匹配插槽中显示select框
      selectScopedSlots: ['unit'],
      // 对于某些自动赋值的input框设为 只读
      readonlyArr: [''],
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      provinceList: [],
      formData: {
        outboundPlatform: null,
        inventoryStatus: 'CERTIFIED_PRODUCTS',
      },
      selectedGoodsOrGroup: {},
      selectedGoodsOrGroupArray: [],
      currentGood: {},
      imeiSn: '', // 快捷 IMEI/SN 查询输入
      imeiSnLoading: false, // 快捷 IMEI/SN 查询 loading
      data: [],
      selectOptionsLoading: false,
      isImportData: false, //批量导入弹窗
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: api.batchImportPurchaseOrderItems,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      }, //批量导入模板信息
      sessionId: '',
      currentShop: {},
      stateData: [],
      pageNo: 1,
      pageSize: 20,
      pages: '',
      curState: [],
      transferredAllQuantity: 0,
      issuedAllQuantity: 0,
      receivedAllQuantity: 0,
      submitLoading: false,
      inventoryBatchModalVisible: false,
      inventoryBatchBarcode: '',
      inventoryBatchWarehouseCode: '',
      inventoryBatchGoodsId: null,
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    this.modalInfo.modalTitle = this.$t('批量导入调拨单商品')
    if (!this.$route.meta.keepAlive) {
      let data = this.$options.data()
      for (let key in data) {
        this[key] = data[key]
      }
    }
    this.init()
  },
  watch: {
    editShow(newType) {
      let index = this.columns.findIndex((v) => v.dataIndex === 'delect')
      let ind = this.columnsDetail.findIndex((v) => v.dataIndex === 'delect')
      if (newType) {
        if (index > 0) {
          this.columns.splice(index, 1)
        }
        if (ind > 0) {
          this.columnsDetail.splice(ind, 1)
        }
      } else {
        if (index < 0) {
          this.columns.push({
            title: this.$t(`form.Operation`),
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
        if (ind < 0) {
          this.columnsDetail.push({
            title: this.$t(`form.Operation`),
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
      }
    },
    isInfoShow(newType) {
      let index = this.columns.findIndex((v) => {
        return v.dataIndex == 'delect'
      })
      let ind = this.columnsDetail.findIndex((v) => {
        return v.dataIndex == 'delect'
      })
      console.log(newType, index, ind)
      if (newType) {
        if (index < 0) {
          this.columns.push({
            title: this.$t(`form.Action`),
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
        if (ind < 0) {
          this.columnsDetail.push({
            title: this.$t(`form.Action`),
            dataIndex: 'delect',
            width: 120,
            scopedSlots: {
              customRender: 'delect',
            },
          })
        }
      } else {
        if (index > 0) {
          this.columns.splice(index, 1)
        }
        if (ind > 0) {
          this.columnsDetail.splice(ind, 1)
        }
      }
    },
    tableData: {
      handler: function (data) {
        this.transferredAllQuantity = data.reduce(
          (a, b) => {
            if (!a.arr.includes(b.barcode)) {
              a.arr.push(b.barcode)
              a.num = add(a.num, Number(b.transferredQuantity) || 0)
              return a
            }
            return a
          },
          { arr: [], num: 0 }
        ).num
        this.issuedAllQuantity = data.reduce(
          (a, b) => {
            if (!a.arr.includes(b.barcode)) {
              a.arr.push(b.barcode)
              a.num = add(a.num, Number(b.issuedQuantity) || 0)
              return a
            }
            return a
          },
          { arr: [], num: 0 }
        ).num
        this.receivedAllQuantity = data.reduce(
          (a, b) => {
            if (!a.arr.includes(b.barcode)) {
              a.arr.push(b.barcode)
              a.num = add(a.num, Number(b.receivedQuantity) || 0)
              return a
            }
            return a
          },
          { arr: [], num: 0 }
        ).num
      },
    },
  },
  methods: {
    Formatter: formatter,
    // 处理表格数据 将barcode相同的放在一起 方便相同项合并
    init() {
      this.sessionId = getCookie('d_session_id')
      this.currentShop = JSON.parse(localStorage.getItem('currentShop'))
      this.getList()
      _self = this
    },
    refreshHandle() {
      this.getList()
    },
    setRowSpan(datas) {
      var onlyObj = {}
      datas = datas.sort((a, b) => (a.skuName < b.skuName ? -1 : 1))
      datas.forEach((item) => {
        onlyObj[item.barcode] = []
      })
      datas.forEach((item) => {
        for (let o in onlyObj) {
          if (item.barcode == o) {
            onlyObj[o].push(item)
          }
        }
      })
      var tempData = []
      for (let o in onlyObj) {
        let transferNum = 0
        let issuedQuantity = 0
        let receivedQuantity = 0
        onlyObj[o].forEach((item) => {
          if (!isNaN(item.quantity)) {
            transferNum += item.quantity
          }
          if (!(!this.editShow || (this.editShow && this.isInfoShow))) {
            issuedQuantity += item.outboundQuantitySum
            receivedQuantity += item.inboundQuantitySum
          }
        })
        onlyObj[o].forEach((v, i) => {
          v.key = i + 1
          v.transferredQuantity = transferNum
          if (!(!this.editShow || (this.editShow && this.isInfoShow))) {
            v.issuedQuantity = issuedQuantity
            v.receivedQuantity = receivedQuantity
          }
        })
        tempData.push(...onlyObj[o])
      }
      this.tableData = [...tempData]
    },
    mergeCells(text, data, key, index) {
      // 上一行该列数据是否一样
      if (index !== 0 && text === data[index - 1][key]) {
        return 0
      }
      let rowSpan = 1
      // 判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break
        }
        rowSpan++
      }
      return rowSpan
    },
    // 查询barcode可用库存
    queryInventory(barcode) {
      // 将选中的商品信息修改成数组格式
      let barcodeList = []
      barcodeList.push(barcode)
      http({
        instance: _self,
        url: api.querySkuStock,
        type: 'post',
        data: {
          warehouseCode: this.formData.outboundWarehouseCode,
          barcodeList: barcodeList,
        },
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.currentGood.skuStockData = res.result[barcode] //存所有类型库存
            this.currentGood.availableInventory = res.result[barcode][this.availableQuantityType]
            this.barcodeCaseNo(this.currentGood.barcode)
            this.currentGood.skuCategory =
              this.currentGood.categoryName || this.currentGood.category
            this.currentGood.skuStyle = this.currentGood.skuStyleValue

            this.currentGood.transferredQuantity = ''
            this.currentGood.unitPriceIncludingTax = '' //含税单价
            this.currentGood.editable = true
            if (this.currentGood.unitList.length) {
              this.currentGood.unit = this.currentGood.unitList?.find(
                (item) => item.procurementUnit
              )?.unitNameFull
            } else {
              this.currentGood.unit = '个'
            }
            this.tableData.push({ ...this.currentGood })
            this.setRowSpan(this.tableData)
          }
        },
      })
    },
    //出库仓改变 sku可用库存改变
    outboundWarehouseCodeChange(val) {
      let newData = [...this.tableData]
      let barcodeList = newData.map((v) => v.barcode)
      barcodeList.length ? this.queryInventoryList(val, barcodeList) : ''
    },
    // 查多个sku的可用库存
    queryInventoryList(warehouseCode, barcodeList) {
      http({
        instance: _self,
        url: api.querySkuStock,
        type: 'post',
        data: {
          warehouseCode: warehouseCode,
          barcodeList: barcodeList,
        },
        hasLoading: true,
        success: (res) => {
          let newData = [...this.tableData]
          newData.forEach((v) => {
            v.skuStockData = res.result[v.barcode] //存所有类型库存
            v.availableInventory = res.result[v.barcode][this.availableQuantityType]
          })
          this.setRowSpan(newData)
        },
      })
    },
    async getList() {
      if (this.$route.query.id) {
        this.transferOrderId = this.$route.query.id
        this.editShow = true
        this.isEdit = true
        this.loading = true
        this.getOrderActionList()
        let res = await http({
          instance: _self,
          url: api.transferOrderDetail,
          type: 'post',
          data: {
            transferOrderId: this.transferOrderId,
          },
        })
        let newData = res.result.transferOrderItemResVOS.sort((a, b) => {
          a.skuNumber - b.skuNumber
        })
        this.tableData = [...newData]
        let barcodeList = newData.map((v) => v.barcode)
        this.formData = res.result
        this.queryInventoryList(this.formData.outboundWarehouseCode, barcodeList)
        this.loading = false
        this.$forceUpdate()
      }
    },
    // 更新调拨信息
    createForm() {
      if (this.isRent) {
        this.formData.needMergeSku = 0
      }
      http({
        instance: _self,
        url: api.transferOrderUpdateTransferOrderInfo,
        type: 'post',
        data: {
          ...this.formData,
        },
        hasLoading: false,
        success() {
          _self.getList()
          _self.isShow = !_self.isShow
        },
      })
    },
    // 更新调拨商品信息
    createInfoForm() {
      console.log(this.tableData)
      this.tableData.forEach((res) => {
        if (!res.caseNo) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`layer.CaseNoNoEmpty`) + '[' + res.barcode + ']',
          })
          throw Error()
        }
        if (!res.quantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`layer.TransferQuantityNoEmpty`) + '[' + res.barcode + ']',
          })
          throw Error()
        }
      })
      http({
        instance: _self,
        url: api.transferOrderUpdateTransferOrderItems,
        type: 'post',
        data: {
          transferOrderId: this.transferOrderId,
          transferOrderItemReqVOS: this.tableData,
        },
        hasLoading: false,
        success() {
          _self.getList()
          _self.isInfoShow = !_self.isInfoShow
        },
      })
    },
    cancelEdit() {
      this.getList()
      this.isShow = !this.isShow
    },
    cancelInfoEdit() {
      this.getList()
      this.isInfoShow = !this.isInfoShow
    },
    chooseEstimatedArrivalTime(data) {
      this.formData.estimatedArrivalTime = data.data
    },
    handleChangeSku(data) {
      console.log('data: ', data)
      this.currentGood = data
      this.currentGood.skuNumber = this.currentGood.brandSku
    },
    handleImeiSnChange() {
      if (this._imeiSnTimer) clearTimeout(this._imeiSnTimer)
      const val = (this.imeiSn || '').trim()
      if (!val) return
      this._imeiSnTimer = setTimeout(() => {
        this.queryByImeiSn(val)
      }, 500)
    },
    queryByImeiSn(imei) {
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('layer.PleaseShippingWarehouse'),
        })
        return
      }
      this.imeiSnLoading = true
      http({
        type: 'post',
        url: api.queryStockListSimple,
        data: { pageNo: 1, pageSize: 1, imei },
        hasLoading: false,
        success: (res) => {
          this.imeiSnLoading = false
          const item = res?.result?.list?.[0]
          if (!item) {
            this.$message.warning(this.$t('未找到对应库存记录'))
            return
          }
          const payload = {
            skuCode: item.skuCode || item.barcode,
            skuName: item.skuName || item.productName,
            productName: item.productName,
            inventoryItemId: item.inventoryItemId,
            barcode: item.barcode,
            unitPrice: item.unitPrice,
            selectedSpecs: item.styleMap || {},
            raw: item,
            _fromImeiSn: true,
          }
          if (!payload.skuCode) {
            this.$message.warning(this.$t('库存记录中未包含 SKU 编码，请手动选择'))
            return
          }
          this.onSkuSelected(payload)
          this.imeiSn = ''
        },
        fail: () => {
          this.imeiSnLoading = false
        },
      })
    },
    showSkuModal() {
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseShippingWarehouse`),
        })
        return
      }
      this.$refs.skuModal.open()
    },
    onSkuSelected(val) {
      const skuStyleValue = [
        val.selectedSpecs.颜色,
        val.selectedSpecs.运行内存,
        val.selectedSpecs.机身存储,
        val.selectedSpecs.成新,
        '国行',
      ]
      const obj = {
        ...val,
        barcode: val.skuCode,
        skuStyleValue: skuStyleValue.join(','), //按颜色、运行内存、机身存储、成新 拼接
        unitList: [],
      }
      obj.skuName = obj.skuName || obj.modelName + '-' + skuStyleValue.join(' ')
      this.currentGood = obj
      this.addGoodsToTable()
    },
    handleChange(value, barcode, colName, index) {
      const newData = [...this.tableData]
      if (colName === 'unitPriceIncludingTax') {
        newData.forEach((item) => {
          if (barcode === item.barcode) {
            item[colName] = value
          }
        })
      } else {
        newData[index][colName] = value
      }
      this.setRowSpan(newData)
    },
    // select 框 change
    onChangeSelect($event, barcode, colName) {
      const newData = [...this.tableData]
      newData.forEach((item) => {
        console.log(item)
        if (barcode === item.barcode) {
          item[colName] = $event
        }
      })
      this.tableData = newData
    },
    onDelect(index) {
      const newData = [...this.tableData]
      newData.splice(index, 1)
      this.setRowSpan([...newData])
    },
    addGoodsToTable() {
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseShippingWarehouse`),
        })
        return
      }
      if (this.currentGood.skuName) {
        this.queryInventory(this.currentGood.barcode)
      }
    },
    // 添加商品同一个barcode箱号不能一样并且添加箱号依次顺序增加
    barcodeCaseNo(barcode) {
      let tempData = [...this.tableData]
      let newData = tempData.filter((v) => v.barcode == barcode)
      if (newData.length === 0) {
        this.currentGood.caseNo = 1
      } else {
        newData.sort((a, b) => b.caseNo - a.caseNo)
        this.currentGood.caseNo = newData[0].caseNo + 1
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 批次号导入
    batchNoImportFn() {
      if (!this.formData.batchNo) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleaseBatchNo`),
        })
        return
      }
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseShippingWarehouse`),
        })
        return
      }
      http({
        instance: this,
        url: api.advancedShippingNoteSearchItemsByBatchNo,
        type: 'post',
        data: {
          batchNo: this.formData.batchNo,
        },
        hasLoading: true,
        success: (res) => {
          let transferOrderItem = res.result.transferOrderItemResVOS
          transferOrderItem.map((v) => {
            v.editable = true
          })

          let newData = [...this.tableData]
          newData.push(...transferOrderItem)
          let barcodeList = newData.map((v) => v.barcode)
          this.tableData = [...newData].sort((a, b) => {
            a.skuNumber - b.skuNumber
          })
          this.queryInventoryList(this.formData.outboundWarehouseCode, barcodeList)
        },
      })
    },
    // 批量删除sku
    batchDelFn() {
      if (this.selectedRowKeys.length === 0) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
        return
      }
      this.tableData = this.tableData.filter((item, index) => {
        return !this.selectedRowKeys.includes(index)
      })
      this.setRowSpan([...this.tableData])
      this.selectedRowKeys = []
    },
    getProvinceList() {
      http({
        instance: this,
        url: api.regionList,
        type: 'post',
        data: {
          data: {
            parentId: '',
            regionType: 1,
          },
        },
        success: (res) => {
          if (res.code == 200) {
            this.provinceList = res.data
          }
        },
      })
    },
    onEdit() {
      this.editShow = false
      this.isEdit = false
      this.tableData.forEach((item) => {
        item.editable = true
      })
    },
    onSubmit: debounce(async function () {
      this.formData.transferOrderItemReqVOS = this.tableData
      if (this.isRent) {
        this.formData.needMergeSku = 0
      }
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleaseShippingWarehouse`),
        })
        return
      }
      if (!this.formData.inboundWarehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (this.formData.needMergeSku === undefined) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: _self.$t('请选择是否合并相同商品'),
        })
        return
      }
      this.tableData.forEach((res) => {
        if (!res.caseNo) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`layer.CaseNoNoEmpty`) + '[' + res.barcode + ']',
          })
          throw Error()
        }
        if (!res.quantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`layer.TransferQuantityNoEmpty`) + '[' + res.barcode + ']',
          })
          throw Error()
        }
        if (res.transferredQuantity > res.availableInventory) {
          console.log(res.transferredQuantity > res.availableInventory)
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: _self.$t(`layer.PleaseTransferQuantity`) + '[' + res.barcode + ']',
          })
          throw Error()
        }
      })
      const data = deepClone(this.formData)
      data.bu_id = this.$store.getters.partyId
      data.shopPlatform = this.currentShop.platform
      data.shopNick = this.currentShop.shopCode
      console.log(data)
      this.submitLoading = true
      await http({
        instance: this,
        url: api.transferOrderSave,
        data,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.transferOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.SavingSucceeded`),
            })
            this.$router.back()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: _self.$t(`layer.CreateFailed`),
            })
          }
        },
      })
      this.submitLoading = false
    }),
    handleCancel() {
      this.$router.back()
    },
    handleOk() {
      http({
        instance: this,
        url: api.autoCreateAsn,
        data: {
          purchaseOrderId: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.CreateSuccess`),
            })
            this.$router.push({
              name: 'addAdvancedShippingNote',
              query: { id: res.result.asnId },
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: _self.$t(`layer.CreateFailed`),
            })
          }
        },
      })
    },
    onReview: debounce(function () {
      http({
        instance: this,
        url: api.transferOrderCheck,
        data: {
          transferOrderId: this.transferOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.transferOrderId) {
            this.getList()
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`form.AUDIT_SUCCESS`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t('layer.CreateFailed'),
            })
          }
        },
      })
    }),
    onVoidOrder: debounce(function () {
      http({
        instance: this,
        url: api.transferOrderCancel,
        data: {
          transferOrderId: this.transferOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.transferOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: _self.$t(`layer.OrderVoided`),
            })
            this.getList()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: _self.$t(`layer.CreateFailed`),
            })
          }
        },
      })
    }),
    backForm() {
      this.$router.back()
    },
    // 导入商品信息数据
    importData(info) {
      console.log(info)
      const status = info.file.status
      if (status === 'done') {
        console.log(info)
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          // push到表格列表中
          let tempDate = [...this.tableData]
          tempDate.push(...resultArr)
          this.tableData = this.setRowSpan([...tempDate])
          this.isInfoShow = true
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.isImportData = false
    },
    async getOrderActionList() {
      let res = await http({
        url: api.transferOrderAction,
        type: 'post',
        data: {
          transferOrderId: this.transferOrderId,
        },
      })
      this.orderActions = res.result
    },
    changeInventoryStatus() {
      this.$nextTick(() => {
        this.tableData.forEach((item) => {
          item.availableInventory = item.skuStockData[this.availableQuantityType]
        })
      })
    },
    showImportModal() {
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF20230411.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : ''
    },
    isBatchCodeSelectable(record) {
      const batchCode = this.formatBatchCode(record?.batchCode)
      return !!batchCode && Number(record?.availableQuantity || 0) > 0
    },
    parseNote(text) {
      if (!text) return null
      if (typeof text !== 'string') return null
      if (text.startsWith('{') && text.endsWith('}')) {
        try {
          const obj = JSON.parse(text)
          if (obj && typeof obj === 'object') {
            return obj
          }
        } catch {
          return null
        }
      }
      return null
    },
    formatImei(imei) {
      if (!imei) return ''
      if (typeof imei === 'string' && imei.startsWith('[') && imei.endsWith(']')) {
        try {
          const arr = JSON.parse(imei)
          if (Array.isArray(arr)) return arr.join(',')
        } catch (e) {
          console.log(e)
        }
      }
      return imei
    },
    formatBatchCode(batchCode) {
      if (Array.isArray(batchCode)) {
        return batchCode.filter((item) => item).join(',')
      }
      if (typeof batchCode === 'string') {
        const trimCode = batchCode.trim()
        if (!trimCode) {
          return ''
        }
        if (trimCode.startsWith('[')) {
          try {
            const parseResult = JSON.parse(trimCode)
            if (Array.isArray(parseResult)) {
              return parseResult.filter((item) => item).join(',')
            }
          } catch (e) {
            return trimCode
          }
        }
        return trimCode
      }
      if (batchCode === null || batchCode === undefined) {
        return ''
      }
      return `${batchCode}`
    },
    async openInventoryBatchModal(record) {
      if (!this.transferOrderId || !record.transferOrderItemId) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('当前商品缺少调拨单商品ID，无法指定库存批次'),
        })
        return
      }
      if (!record.barcode) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: '当前商品缺少条码，无法查询库存明细',
        })
        return
      }
      if (!this.formData.outboundWarehouseCode) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('layer.PleaseShippingWarehouse'),
        })
        return
      }
      this.inventoryBatchBarcode = record.barcode
      this.inventoryBatchWarehouseCode = this.formData.outboundWarehouseCode
      this.inventoryBatchGoodsId = record.transferOrderItemId
      this.inventoryBatchModalVisible = true
    },
    closeInventoryBatchModal() {
      this.inventoryBatchModalVisible = false
      this.inventoryBatchBarcode = ''
      this.inventoryBatchWarehouseCode = ''
      this.inventoryBatchGoodsId = null
    },
    onInventoryBatchSelectChange(selectedRowKeys) {
      // 已交由 InventoryBatchSelectModal 组件处理，这里保留避免旧代码误触发
      return selectedRowKeys
    },
    async saveInventoryBatchSelection() {
      // 已交由 InventoryBatchSelectModal 组件处理，这里保留避免旧代码误触发
      return
    },
  },
  computed: {
    ...mapGetters(['isRent']),
    updateUrl() {
      return api.updateTransferOrderItemInventoryInfo
    },
    isDisabled() {
      return this.isEdit && (!this.isEdit || !this.isShow)
    },
    columns() {
      return [
        {
          title: this.$t(`form.ProductName`),
          dataIndex: 'skuName',
          width: 200,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          slots: { title: 'ProductBarcode' },
          dataIndex: 'barcode',
          width: 100,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          slots: { title: 'SkuNumber' },
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.CommoditySpecification`),
          dataIndex: 'skuStyle',
          width: 100,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.Unit`),
          dataIndex: 'unit',
          width: 100,
          scopedSlots: { customRender: 'unit' },
          customCell: (record, index) => {
            return {
              style: { display: record.key === 1 ? undefined : 'none' },
              attrs: {
                rowSpan: this.mergeCells(record['barcode'], this.tableData, 'barcode', index),
              },
            }
          },
        },
        {
          title: this.$t(`form.AvailableInventory`),
          dataIndex: 'availableInventory',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.availableInventory != undefined
                    ? toThousands(record.availableInventory)
                    : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.TransferredQuantity`),
          dataIndex: 'transferredQuantity',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.transferredQuantity != undefined
                    ? toThousands(record.transferredQuantity)
                    : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          dataIndex: 'caseNo',
          width: 100,
          slots: { title: 'BoxNumber' },
          scopedSlots: {
            customRender: 'caseNo',
          },
        },
        {
          width: 100,
          slots: { title: 'Quantity' },
          dataIndex: 'quantity',
          scopedSlots: {
            customRender: 'quantity',
          },
        },
        {
          title: this.$t(`单价`),
          width: 100,
          dataIndex: 'unitPrice',
        },
        {
          title: this.$t(`费用`),
          width: 100,
          dataIndex: 'feeAmount',
          scopedSlots: { customRender: 'feeAmount' },
        },
        {
          title: this.$t(`form.note`),
          dataIndex: 'note',
          width: 200,
          scopedSlots: {
            customRender: 'note',
          },
        },
        ...(this.isRent
          ? [
              {
                title: this.$t('库存来源'),
                dataIndex: 'inventoryNote',
                width: 220,
                scopedSlots: {
                  customRender: 'inventoryNote',
                },
              },
            ]
          : []),
        {
          title: this.$t(`form.Operation`),
          dataIndex: 'delect',
          width: 100,
          scopedSlots: {
            customRender: 'delect',
          },
        },
      ]
    },
    columnsDetail() {
      return [
        {
          title: this.$t(`form.ProductName`),
          dataIndex: 'skuName',
          width: 200,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          slots: { title: 'ProductBarcode' },
          dataIndex: 'barcode',
          width: 100,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          slots: { title: 'SkuNumber' },
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.CommoditySpecification`),
          dataIndex: 'skuStyle',
          width: 100,
          customRender: (text, record, index) => {
            const obj = {
              children: text !== null ? text : '',
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.Unit`),
          dataIndex: 'unit',
          width: 100,
          scopedSlots: { customRender: 'unit' },
          customCell: (record, index) => {
            return {
              style: { display: record.key === 1 ? undefined : 'none' },
              attrs: {
                rowSpan: this.mergeCells(record['barcode'], this.tableData, 'barcode', index),
              },
            }
          },
        },
        {
          title: this.$t(`form.AvailableInventory`),
          dataIndex: 'availableInventory',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.availableInventory != undefined
                    ? toThousands(record.availableInventory)
                    : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.TransferredQuantity`),
          dataIndex: 'transferredQuantity',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.transferredQuantity != undefined
                    ? toThousands(record.transferredQuantity)
                    : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.IssuedQuantity`),
          dataIndex: 'issuedQuantity',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.issuedQuantity != undefined ? toThousands(record.issuedQuantity) : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          title: this.$t(`form.ReceivedQuantity`),
          dataIndex: 'receivedQuantity',
          width: 100,
          customRender: (text, record, index) => {
            var child = this.$createElement('span', {
              domProps: {
                innerHTML:
                  record.receivedQuantity != undefined ? toThousands(record.receivedQuantity) : '',
              },
            })
            const obj = {
              children: child,
              attrs: {},
            }
            obj.attrs.rowSpan = this.mergeCells(record['barcode'], this.tableData, 'barcode', index)
            return obj
          },
        },
        {
          dataIndex: 'caseNo',
          width: 100,
          slots: { title: 'BoxNumber' },
          scopedSlots: {
            customRender: 'caseNo',
          },
        },
        {
          dataIndex: 'quantity',
          width: 100,
          slots: { title: 'Quantity' },
          scopedSlots: {
            customRender: 'quantity',
          },
        },
        {
          title: this.$t(`单价`),
          width: 100,
          dataIndex: 'unitPrice',
        },
        {
          title: this.$t(`费用`),
          width: 100,
          dataIndex: 'feeAmount',
        },
        {
          title: this.$t(`form.note`),
          dataIndex: 'note',
          width: 200,
          scopedSlots: {
            customRender: 'note',
          },
        },
        ...(this.isRent
          ? [
              {
                title: this.$t('库存来源'),
                dataIndex: 'inventoryNote',
                width: 220,
                scopedSlots: {
                  customRender: 'inventoryNote',
                },
              },
            ]
          : []),
        {
          title: this.$t(`form.Operation`),
          dataIndex: 'delect',
          width: 100,
          scopedSlots: {
            customRender: 'delect',
          },
        },
      ]
    },
    shippingList() {
      return [
        {
          shippingName: this.$t(`form.OceanShipping`),
          code: 'OceanShipping',
        },
        {
          shippingName: this.$t(`form.LandTransportation`),
          code: 'LandTransportation',
        },
        {
          shippingName: this.$t(`form.LandSeaMixing`),
          code: 'LandSeaMixing',
        },
      ]
    },
    availableQuantityType() {
      let obj = {
        CERTIFIED_PRODUCTS: 'availableQuantity', //正品
        DEFECTIVE_PRODUCTS: 'defectiveQuantity', //次品
      }
      return obj[this.formData.inventoryStatus]
    },
    scrollHeight() {
      let height = window.innerHeight - (this.isEdit ? 220 : 300)
      return height * this.$store.state.rate + 'px'
    },
    inventoryBatchColumns() {
      return [
        {
          title: this.$t('批次编码'),
          dataIndex: 'batchCode',
          width: 180,
          customRender: (text) => this.formatBatchCode(text),
        },
        {
          title: this.$t('可用库存'),
          dataIndex: 'availableQuantity',
          width: 120,
          customRender: (text) => (text !== undefined && text !== null ? toThousands(text) : '-'),
        },
        {
          title: this.$t('库存来源'),
          dataIndex: 'note',
          width: 260,
          customRender: (text) => text,
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createdAt',
          width: 180,
          customRender: (text) => text,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  margin-right: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
</style>
